import React from 'react'
import InfoMessage, {
  InfoMessageContent,
  InfoMessageTextLine,
} from '../InfoMessage'

import { ReactComponent as ResolvedInboxIcon } from '@sketch/icons/archive-box-16-svg'

interface CommentTabMessageNoAnnotationsResolvedProps {
  action?: React.ReactNode
}
const CommentTabMessageNoAnnotationsResolved: React.FC<CommentTabMessageNoAnnotationsResolvedProps> = ({
  action,
}) => {
  return (
    <InfoMessage
      title="No resolved comments"
      action={action}
      icon={<ResolvedInboxIcon role="img" />}
    >
      <InfoMessageContent>
        <InfoMessageTextLine>
          Nobody has marked comments as resolved yet.
        </InfoMessageTextLine>
      </InfoMessageContent>
    </InfoMessage>
  )
}

export default CommentTabMessageNoAnnotationsResolved
